import { ApiTypes } from '../../api/api-types';
import { QUESTION_TYPES } from '../../core/interfaces/general.interface';
import {
  CampaignRespDto,
  ICampaign,
  ICampaignContent,
  ICampaignOptions,
  ICampaignQuestion,
} from './interfaces/campaign.interface';

type CampaignContentDto = ApiTypes.CampaignTakeawayContentResponseDto;
type CampaignQuestionDto = ApiTypes.CampaignTakeawayQuestionResponseDto;
type CampaignOptionDto = ApiTypes.CampaignTakeawayOptionResponseDto;

function toDisplayColumns(value: number | null | undefined): 2 | 3 | 4 | undefined {
  return value === 2 || value === 3 || value === 4 ? value : undefined;
}

/**
 * Adapts the campaign serve DTO into the frontend `ICampaign` the survey flow renders and edits.
 * The narrowings the frontend relies on (question `type` -> QuestionType, `displayColumns` -> 2|3|4)
 * are applied here, once, at this seam — the API call itself stays typed as the generated DTO.
 */
export function toCampaign(dto: CampaignRespDto): ICampaign {
  return {
    campaign: toCampaignContent(dto.campaign),
    info: dto.info,
    demographics: dto.demographics,
  };
}

function toCampaignContent(dto: CampaignContentDto): ICampaignContent {
  return {
    ...dto,
    questions: dto.questions.map(toCampaignQuestion),
  };
}

function toCampaignQuestion(dto: CampaignQuestionDto): ICampaignQuestion {
  return {
    ...dto,
    type: QUESTION_TYPES[dto.type],
    displayColumns: toDisplayColumns(dto.displayColumns),
    options: dto.options?.map(toCampaignOption),
  };
}

function toCampaignOption(dto: CampaignOptionDto): ICampaignOptions {
  return {
    ...dto,
    translations: dto.translations ?? { option: [] },
    value: undefined,
  };
}
